'use client';

import { cn } from '../../lib';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function Error404GhostAnimation(props: IAnimationProps) {
  const { className } = props;

  const loadAnimation = () => import('./raw-json/404/404-error.json');

  return (
    <LazyLottie
      className={cn('Xlottie-404 h-48', className)}
      {...props}
      getAnimationData={loadAnimation}
      id="Error404GhostAnimation"
    />
  );
}
